<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.inventory.info.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无库存记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :defaultParams="defaultParams"
      :actionWidth="120"
    >
      <template slot="row-info" slot-scope="scope">
        <warehouse-inventory-info :inventoryInfo="scope.row" />
      </template>
    </x-table>
  </div>
</template>

<script>
import timeRange from "../../../../components/timeRange.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import warehouseInventoryInfo from "../../../../components/business/warehouseInventoryInfo.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import inventoryDetailPage from "./detail.vue";

export default {
  components: {
    goodsSkuInfo,
    warehouseInventoryInfo,
    customerStoreSelect,
    timeRange,
  },
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        storeGuid: this.pageQuery.storeGuid,
        purchaseGuid: this.pageQuery.purchaseGuid,
        replenishGuid: this.pageQuery.replenishGuid,
        orderGuid: this.pageQuery.orderGuid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "记录信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              refresh,
              title: "库存记录详情",
              component: inventoryDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "关闭",
          linkType: "danger",
          click: (row, tag, refresh) => {
            this.$confirm(`确定取消出入库操作，此操作不可恢复，请谨慎操作?`, "提示", {
              type: "warning",
            }).then(() => {
              this.requestApi(
                "biz.warehouse.inventory.info.cancel",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                { showError: true }
              ).then(() => {
                refresh && refresh();
              });
            });
          },
        },
      ],
    };
  },
};
</script>
